import { OverallStatus } from "../types";

const STYLES: Record<OverallStatus, { label: string; className: string }> = {
  NOT_STARTED: {
    label: "Not Started",
    className: "bg-neutral-200 text-content-secondary",
  },
  IN_PROGRESS: {
    label: "In Progress",
    className: "bg-blue-100 text-blue-700",
  },
  AWAITING_MANUAL: {
    label: "Awaiting Manual",
    className: "bg-orange-100 text-orange-700",
  },
  FAILED: {
    label: "Failed",
    className: "bg-red-100 text-red-700",
  },
  COMPLETED: {
    label: "Completed",
    className: "bg-green-100 text-green-700",
  },
};

export function OverallStatusBadge({ status }: { status: OverallStatus }) {
  const style = STYLES[status];
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${style.className}`}
    >
      {style.label}
    </span>
  );
}
